module.exports = __webpack_public_path__ + "static/media/s9 — kopia.d5eb7ad8.jpg";